import { contactData, appData, carouselData, aboutData, indexData } from '@/mocks/homeData';

export function SectionContact() {
  return (
    <section id="contact" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          {contactData.title}
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center max-w-[560px] mx-auto">
          {contactData.desc}
        </p>

        <div className="mt-8 md:mt-10 max-w-[600px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {contactData.items.map((item, i) => (
              <div
                key={i}
                className="flex items-start gap-3 p-4 bg-background-100 rounded-xl border border-background-200/60"
              >
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-100/70 shrink-0">
                  <i className={`${item.icon} text-primary-500 text-base`}></i>
                </div>
                <div className="min-w-0">
                  <p className="text-xs text-foreground-500 whitespace-nowrap">{item.label}</p>
                  <p className="mt-0.5 text-sm font-medium text-foreground-900 break-all">{item.value}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function SectionApp() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-gradient-to-br from-primary-500/8 via-background-100/60 to-accent-500/8">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          {appData.title}
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          {appData.desc}
        </p>

        <div className="mt-8 md:mt-10 flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex flex-col sm:flex-row gap-6 md:gap-8">
            {appData.platforms.map((platform, i) => (
              <div
                key={i}
                className="flex flex-col items-center text-center p-6 md:p-8 bg-background-50 rounded-2xl border border-background-200/60"
              >
                <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-primary-100/70">
                  <i className={`${platform.icon} text-primary-500 text-2xl`}></i>
                </div>
                <h3 className="mt-4 text-base md:text-lg font-semibold text-foreground-900">
                  {platform.name}
                </h3>
                <p className="mt-1 text-xs text-foreground-500">{platform.desc}</p>
                <div className="mt-4 w-32 h-32 md:w-36 md:h-36 bg-background-200 rounded-xl flex items-center justify-center">
                  <span className="text-xs text-foreground-500">{platform.qrLabel}</span>
                </div>
                <button className="mt-4 px-6 py-2.5 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-full transition-colors whitespace-nowrap cursor-pointer">
                  立即下载
                </button>
              </div>
            ))}
          </div>

          <div className="flex-1 w-full">
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
              {appData.features.map((feat, i) => (
                <div
                  key={i}
                  className="flex items-center gap-2 px-4 py-3 bg-background-50 rounded-lg border border-background-200/60"
                >
                  <i className="ri-checkbox-circle-fill text-primary-500 text-sm"></i>
                  <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{feat}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function SectionCarousel() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-100/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          焦点专题
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          深度漫画文化内容，带你发现更多精彩
        </p>

        <div className="mt-8 md:mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselData.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-xl border border-background-200/60 hover:border-primary-200 overflow-hidden transition-all cursor-pointer"
            >
              <div className="relative w-full aspect-[16/9] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={`${item.title}专题封面`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 text-xs font-semibold bg-primary-500 text-background-50 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors leading-snug">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function SectionAbout() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          {aboutData.title}
        </h2>

        <div className="mt-8 md:mt-10 max-w-[800px] mx-auto">
          <div className="space-y-4">
            {aboutData.paragraphs.map((p, i) => (
              <p key={i} className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {p}
              </p>
            ))}
          </div>

          <div className="mt-8 md:mt-10 grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-5">
            {aboutData.stats.map((stat, i) => (
              <div
                key={i}
                className="text-center p-4 md:p-5 bg-background-100 rounded-xl border border-background-200/60"
              >
                <div className="text-xl md:text-2xl font-heading font-bold text-primary-500 whitespace-nowrap">
                  {stat.value}
                </div>
                <div className="mt-1 text-xs md:text-sm text-foreground-500">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function SectionIndex() {
  return (
    <section id="index" className="w-full py-14 md:py-20 bg-background-100/60">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          主题索引
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          按分类快速找到你想看的漫画，总有一个类型适合你
        </p>

        <div className="mt-8 md:mt-10 max-w-[900px] mx-auto">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
            {indexData.map((item, i) => (
              <a
                key={i}
                href={item.href}
                onClick={(e) => {
                  e.preventDefault();
                  const el = document.querySelector(item.href);
                  if (el) {
                    const top = el.getBoundingClientRect().top + window.scrollY - 80;
                    window.scrollTo({ top, behavior: 'smooth' });
                  }
                }}
                className="group flex flex-col items-center justify-center p-5 md:p-6 bg-background-50 rounded-xl border border-background-200/60 hover:border-primary-200 hover:bg-primary-50/30 transition-all cursor-pointer"
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                  {item.category}
                </h3>
                <span className="mt-2 text-xs text-foreground-500">
                  {item.count.toLocaleString()} 部
                </span>
              </a>
            ))}
            <div className="flex flex-col items-center justify-center p-5 md:p-6 bg-accent-100/50 rounded-xl border border-accent-200/60">
              <span className="text-sm md:text-base font-semibold text-accent-700 whitespace-nowrap">
                更多分类
              </span>
              <span className="mt-2 text-xs text-accent-500">持续更新中</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}